import { FormFields, FormValidationSchema } from '@/common/interfaces';

import type { ExternalRedirect } from './entities/externalRedirect.entity';

// Тип цілі зовнішнього редіректу.
export const enum ExternalRedirectTargetType {
  SystemDomain = 'systemDomain',
  ExternalDomain = 'externalDomain',
  Site = 'site',
} ;

export enum ExternalRedirectFormInputs {
  FromDomainId = 'fromDomainId',
  SourceType = 'sourceType',
  SourceNodeId = 'sourceNodeId',
  SourcePath = 'sourcePath',
  ToType = 'toType',
  ToDomainId = 'toDomainId',
  ToExternalDomain = 'toExternalDomain',
  ToSiteId = 'toSiteId',
  TargetType = 'targetType',
  TargetNodeId = 'targetNodeId',
  TargetPath = 'targetPath',
  StatusCode = 'statusCode',
  MatchMode = 'matchMode',
  ForVisitor = 'forVisitor',
  IsActive = 'isActive',
  SiteId = 'siteId',
}

export type ExternalRedirectFormFields = FormFields<typeof ExternalRedirectFormInputs>;

export type ExternalRedirectFormValidationSchema = FormValidationSchema<ExternalRedirectFormFields>;

export type ExternalRedirectsListTableDataObj = {
  id: ExternalRedirect['id'];
  isActive: ExternalRedirect['isActive'];
  matchMode: ExternalRedirect['matchMode'];
  statusCode: ExternalRedirect['statusCode'];
  forVisitor: ExternalRedirect['forVisitor'];
  toType: ExternalRedirect['toType'];
  sourceDomainLabel: string;
  sourceEndpointLabel: string;
  targetDomainLabel: string;
  targetEndpointLabel: string;
};

export type BulkUpdateExternalRedirectsActivityPayload = {
  ids: string[];
  isActive: boolean;
};

export type BulkDeleteExternalRedirectsPayload = {
  ids: string[];
};

export type ExternalRedirectRedundantConflict = {
  redirect: ExternalRedirect;
  overriddenById: string | null;
};

export type ExternalRedirectCyclicConflict = {
  redirect: ExternalRedirect;
};

export type ExternalRedirectConflicts = {
  redundant: ExternalRedirectRedundantConflict[];
  cyclic: ExternalRedirectCyclicConflict[];
};
